export function closeAlert() {
  if (this.alertTimeout) {
    clearTimeout(this.alertTimeout);
    this.alertTimeout = null;
  }
  const alert = {
    ...this.state.alert,
    show: false,
  };
  this.setState({ alert });
}

export function showError(message) {
  if (this.alertTimeout) {
    clearTimeout(this.alertTimeout);
  }
  const alert = {
    message: message,
    type: 'error',
    show: true,
  };
  this.setState({ alert });

  this.alertTimeout = setTimeout(this.actions.alert.closeAlert, 10000);
}

export function showSuccess(message) {
  if (this.alertTimeout) {
    clearTimeout(this.alertTimeout);
  }
  const alert = {
    message: message,
    type: 'success',
    show: true,
  };
  this.setState({ alert });

  this.alertTimeout = setTimeout(this.actions.alert.closeAlert, 10000);
}
